const projects = [
  {
    title: 'Trash Panda MTL',
    imgUrl: 'images/trash-panda.gif',
    linkUrl: 'https://github.com/andres039/Upcycle-Cradle-Montreal',
    desc: 'A web app that allows Montrealers to extend the life of discarded furniture by displaying their location on an interactive map.'
  },
  {
    title: 'Technical Documentation',
    imgUrl: 'images/tech-doc.png',
    linkUrl: 'https://timothy-chan2.github.io/fcc-technical-documentation',
    desc: 'A technical documentation page about JSX.'
  },
  {
    title: 'Product Landing Page',
    imgUrl: 'images/product-landing.png',
    linkUrl: 'https://timothy-chan2.github.io/fcc-product-landing',
    desc: 'The front end of a product landing page for a mobility scooter by Daymak, Inc. Note: The e-mail input field is not connected to a back end.'
  },
  {
    title: 'Survey Form',
    imgUrl: 'images/survey.png',
    linkUrl: 'https://timothy-chan2.github.io/fcc-survey-form',
    desc: 'The front end of a survey form about astronaut Chris Hadfield. Note: The input fields are not connected to a back end.'
  },
  {
    title: 'Tribute Page',
    imgUrl: 'images/tribute.png',
    linkUrl: 'https://timothy-chan2.github.io/fcc-tribute-page',
    desc: 'A tribute about astronaut Chris Hadfield.'
  },
  {
    title: 'Jungle',
    imgUrl: 'images/jungle-rails.png',
    linkUrl: 'https://github.com/timothy-chan2/jungle-rails',
    desc: 'An inherited mini e-commerce application built with Rails 4.2 that required bug fixes and additional features.'
  },
  {
    title: 'Interview Scheduler',
    imgUrl: 'images/scheduler.png',
    linkUrl: 'https://github.com/timothy-chan2/scheduler',
    desc: 'Interview scheduler built with React where a user can create, edit, and delete interview appointments.'
  },
  {
    title: 'TinyApp',
    imgUrl: 'images/tinyapp.gif',
    linkUrl: 'https://github.com/timothy-chan2/tinyapp',
    desc: 'A full stack web app built with Node and Express that allows users to shorten long URLs. Users can select between dark/light theme.'
  },
  {
    title: 'Quizzle',
    imgUrl: 'images/quizzle.png',
    linkUrl: 'https://github.com/Sponicus/Quiz-App',
    desc: 'A web app that lets you create and take quizzes as well as share your quiz results with friends.'
  }
];

export default projects;